import {useState, useEffect} from 'react';
import cn from 'classnames';
import moment from 'jalali-moment';
import {useNavigate} from 'react-router-dom';
import {PostIconTypes} from '../../../../models/post/postIconTypes';
import {getInputGroupRoute} from '../../../../module/dashboard/category/utilities';
import styles from './myAdItem.module.scss';
import EmptyImg from '../../../../assets/image/shared/empty.svg';
import DangerModal from '../../../../components/dangerModal';
import useRemoveAds from '../hooks/useRemoveAdd';
import {DeleteReason} from '../../../../models/utilities/removePostReason';

type TProductItemType = {
  post: TPost;
  icon: PostIconTypes | string;
  inputGroupType: number;
  route?: string;
  refetch: () => void;
};

const MyAdItem = ({
  post,
  icon,
  inputGroupType,
  route,
  refetch,
}: TProductItemType) => {
  const today = new Date();
  const {mutate, isLoading, isSuccess} = useRemoveAds();
  const dateTime = moment(moment(new Date(post.created_at)))
    .locale('fa')
    .from(today); // "a day ago"
  const navigate = useNavigate();
  const [show, setShow] = useState<boolean>(false);

  const handleDelete = () => {
    const payload: IRemovePostPayload = {
      guid: post?.guid,
      type: getInputGroupRoute[post?.input_group?.code],
      delete_reason: DeleteReason?.canceled,
    };
    mutate(payload);
  };

  useEffect(() => {
    if (isSuccess) {
      setShow(false);
      refetch();
    }
  }, [isSuccess]);
  return (
    <>
      <div className={styles.productItem}>
        <div
          onClick={() => {
            navigate(
              route
                ? route
                : '/dashboard/' +
                    getInputGroupRoute[inputGroupType] +
                    '/details/' +
                    post.guid,
              {
                state: {post: post},
              },
            );
          }}
        >
          {post?.main_image ? (
            <img
              loading="lazy"
              src={post?.main_image?.image}
              alt={post?.title}
            />
          ) : (
            <div className={styles['productItem__empty-img']}>
              <img src={EmptyImg} alt={post?.title} />
            </div>
          )}

          {post?.status === 'published' ? (
            <div className={styles['productItem__dateTime']}>
              <span>{dateTime}</span>
            </div>
          ) : post?.status === 'rejected' ? (
            <div className={styles['productItem__rejected']}>
              <span>تایید نشده</span>
            </div>
          ) : post?.status === 'pending' ? (
            <div className={styles['productItem__pending']}>
              <span>در انتظار تایید</span>
            </div>
          ) : (
            ''
          )}
        </div>

        <div
          className={cn(
            styles['productItem__content'],
            'd-flex flex-column pe-3 w-100',
          )}
        >
          <div
            onClick={() => {
              navigate(
                route
                  ? route
                  : '/dashboard/' +
                      getInputGroupRoute[inputGroupType] +
                      '/details/' +
                      post.guid,
                {
                  state: {post: post},
                },
              );
            }}
          >
            <div className="my-2">
              <span className="color-black-1 fw-800 text-break">
                {post?.title}
              </span>
            </div>
            <div className="d-flex flex-column mt-2">
              <div>
                {post?.price_on_call ? (
                  <>تماس با فروشنده</>
                ) : post?.negotiated_price ? (
                  <> توافقی </>
                ) : (
                  <>
                    <small className="fw-800 gray-1">
                      {Number(post?.price).toLocaleString()}{' '}
                    </small>
                    <small className="fw-500 gray-1">تومان</small>
                  </>
                )}
              </div>
            </div>
          </div>
          {post?.status !== 'published' ? (
            <div
              className="d-flex justify-content-end w-100"
              onClick={() => setShow(true)}
            >
              <small className="color-gray-1">حذف آگهی</small>
            </div>
          ) : (
            <div
              className="d-flex justify-content-end w-100"
              onClick={() => {
                navigate(
                  route
                    ? route
                    : '/dashboard/' +
                        getInputGroupRoute[inputGroupType] +
                        '/details/' +
                        post.guid,
                  {
                    state: {post: post},
                  },
                );
              }}
            >
              <small className="color-gray-1">مدیریت آگهی</small>
            </div>
          )}
        </div>
      </div>
      <DangerModal
        show={show}
        setShow={setShow}
        isLoading={isLoading}
        onClick={handleDelete}
        title="آیا از حذف آگهی اطمینان دارید؟"
      />
    </>
  );
};

export default MyAdItem;
